<template>
  <div class="min-h-screen w-full bg-white text-foreground relative">
    <header class="absolute top-0 left-0 p-10">
      <img :src="logoLast" alt="Last.app" class="h-10 w-auto" />
    </header>

    <main class="min-h-screen flex items-center justify-center px-6 py-24">
      <div v-if="!loading" class="w-full max-w-2xl flex flex-col gap-8">
        <h1 class="heading-1 text-center text-foreground">
          {{ t('location-selector.title') }}
        </h1>

        <p
          v-if="locations.length === 0"
          class="text-base text-muted-foreground text-center"
        >
          {{ t('location-selector.zero-locations-error') }}
        </p>

        <ul
          v-else
          class="grid grid-cols-1 md:grid-cols-2 gap-4"
          role="listbox"
          :aria-label="t('location-selector.title')"
        >
          <li v-for="location in locations" :key="location.id" class="flex">
            <button
              type="button"
              role="option"
              :aria-label="location.name"
              class="w-full bg-card text-card-foreground border border-border rounded-2xl px-5 py-6 flex items-center gap-4 transition-colors hover:bg-muted focus-visible:outline-none focus-visible:bg-muted focus-visible:border-primary"
              @click="selectLocationAndContinue(location)"
            >
              <l-icon name="store" size="small" class="text-muted-foreground shrink-0" />
              <span class="flex-1 min-w-0 text-base font-semibold truncate text-left">
                {{ location.name }}
              </span>
              <l-icon
                name="bracket-right"
                size="small"
                class="text-muted-foreground shrink-0"
                aria-hidden="true"
              />
            </button>
          </li>
        </ul>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { LIcon } from '@last/core-ui/paprika'

import { locationsApi } from '@/api/client'
import logoLast from '@/assets/logo-last.svg'
import type { GetRiderLocations200ResponseInner } from '@/openapi'
import { useAuthStore } from '@/store/auth'

const router = useRouter()
const authStore = useAuthStore()
const { t } = useI18n()

const locations = ref<GetRiderLocations200ResponseInner[]>([])
const loading = ref(true)

async function selectLocationAndContinue(location: GetRiderLocations200ResponseInner) {
  await authStore.selectLocation(location)
  router.push({ name: 'customerDisplay' })
}

onMounted(async () => {
  try {
    locations.value = await locationsApi.getRiderLocations()
  } finally {
    loading.value = false
  }
  if (locations.value.length === 1) {
    selectLocationAndContinue(locations.value[0])
  }
})
</script>
